<template>
    <div> <!-- 表格部分 -->
        <el-table :data="loanTable" size="mini" border style="width: 100%" v-loading="loading">
            <!-- id -->
            <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="80"
            ></el-table-column>
            <!-- 名称 -->
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="title"
                    label="标题"
                    min-width="120"
            ></el-table-column>
            <!-- 键 -->
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="creator"
                    label="创建人"
                    min-width="120"
            ></el-table-column>
            <!-- 值 -->
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="创建时间"
                    min-width="120"
            ></el-table-column>
            <!-- 操作 -->
            <el-table-column
                    header-align="center"
                    align="center"
                    label="操作"
                    min-width="120"
            >
                <template slot-scope="scope">
                    <el-button type="text" @click="handleInfo(scope.row)">编辑</el-button>

                </template>
            </el-table-column>
        </el-table>

        <el-dialog v-if="dialogVisible" title="表单" :visible.sync="dialogVisible">
            <el-form :model="submitData" :rules="rules" ref="ruleForm">
                <el-form-item label="标题" :label-width="formLabelWidth" prop="title" style="margin-bottom: 17px">
                    <el-input v-model="submitData.title" autocomplete="off" placeholder="请输入标题" style="width: 300px"></el-input>
                </el-form-item>

                <el-form-item label="内容" :label-width="formLabelWidth" prop="content" style="margin-bottom: 17px">
                    <template style="width: 600px">
                        <div style="width: 600px">
                            <!--  新增时输入 -->
                            <quill-editor
                                    v-model="submitData.content"
                                    ref="myQuillEditor"
                                    :options="editorOption">
                            </quill-editor>
                        </div>
                    </template>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {quillEditor} from "vue-quill-editor"; //调用编辑器
    import 'quill/dist/quill.core.css';
    import 'quill/dist/quill.snow.css';
    import 'quill/dist/quill.bubble.css';

    export default {
        name: "systemArticleManagement",
        components: {
            quillEditor
        },
        data() {
            return {
                type: '20',//'10公告，20系统文章'
                page: 1,//页码
                page_size: 20,//页数
                loanTable: [], //列表
                loading: true, //列表loadding
                dialogVisible: false,//编辑表单页面显示
                formLabelWidth: '60px',
                dialogData: {},//
                submitData: {//表单请求数据
                    id: '',//id
                    sort: '',//排序
                    title: '',//标题
                    type: '20',//‘10公告，20系统文章’
                    status: '',//10启用，20禁用’
                    content: '',//内容
                    index_show: ''//10首页弹框，20不弹框
                },
                rules: {
                    title: [
                        {required: true, message: '请输入标题', trigger: 'blur'},
                    ],
                    content: [
                        {required: true, message: '请输入详情', trigger: 'blur'},
                    ],
                },
                editorOption: {}
            }
        },
        mounted() {
            this.getData({
                page: 1,
                page_size: 20,
                type: "20",
                status: ""
            });
        },
        computed: {//表单文本框
            editor() {
                return this.$refs.myQuillEditor.quill;
            },
        },
        methods: {
            // 编辑表单显示
            handleInfo(row) {
                this.dialogData = JSON.parse(JSON.stringify(row));
                this.submitData.id = this.dialogData.id;
                this.submitData.sort = this.dialogData.sort;
                this.submitData.title = this.dialogData.title;
                this.submitData.status = this.dialogData.status.value;
                this.submitData.content = this.dialogData.content;
                this.submitData.index_show = this.dialogData.index_show.value;
                this.dialogVisible = true;
            },
            // 页面显示
            getData(params) {
                this.$api.post("/api/Message/noticeList?page=" + params.page, params, res => {
                    this.loanTable = res.data.list;
                    //渲染结束后取消加载
                    this.loading = false;
                })
            },
            // 编辑表单校验
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        // 编辑确定
                        this.$api.post("/api/Message/noticeForm", this.submitData, res => {
                            if (res.status == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '操作成功',
                                    duration: 1000,
                                });
                                this.dialogVisible = false;
                                this.getData({
                                    page: 1,
                                    page_size: 20,
                                    type: "20",
                                    status: ""
                                });
                            } else {
                                this.$message.error(res.msg);
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
        }
    }
</script>

<style scoped>
    /*表单文本框*/
    /deep/ .ql-container {
        height: 300px !important;
    }
</style>
